export default "__VITE_ASSET__wMX8EznJ__"